import { Bloodhound } from "common/components/typeahead";
import { request } from "common/components/request";
import { references } from "common/helpers/references";

export const typeaheadMixin = {
    makeBloodhoundInstance(data, display = "label") {
        const instance = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace(display),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            local: data
        });
        
        const originalSearch = instance.search;
        
        // Wrap search with our function to filter already selected group of results
        if (this.stepsTypeahead) {
            instance.search = (q, sync) => {
                originalSearch.call(instance, q, (results) => {
                    const currentGroups = this.stepsTypeahead.getTokensGroups();
                    sync(results.filter((r) => !currentGroups.includes(r.group)));
                });
            };
        }
        
        return instance;
    },
    
    getMerchantsModel() {
        const allTopLevelMerchants = references.getAliasGroupByType("merchant").map((merchant) => ({
            value: merchant.id,
            label: merchant.display_name,
            group: "merchant_ref"
        }));
        
        return {
            display: ["label"],
            source: this.makeBloodhoundInstance(allTopLevelMerchants, ["label", "value"]), // Merchants should be searchable by both id and display name
            templates_suggestion: (data) => `<div><strong>${data.label}</strong> <em>under Merchants</em></div>`
        };
    },
    
    async getProvidersModel() {
        const allProviders = await request("/admin/providers");
    
        return {
            display: ["value"],
            source: this.makeBloodhoundInstance(allProviders.map((provider) => ({
                value: provider,
                label: provider,
                group: "processor_name"
            }))),
            templates_suggestion: (data) => `<div><strong>${data.label}</strong> <em>under Providers</em></div>`
        };
    },
    
    getProtocolsModel() {
        return {
            display: "label",
            source: this.makeBloodhoundInstance([{
                value: "web-driver",
                label: "UI",
                group: "protocol"
            }, {
                value: "api",
                label: "API",
                group: "protocol"
            }, {
                value: "sftp",
                label: "SFTP",
                group: "protocol"
            }, {
                value: "ftp",
                label: "FTP",
                group: "protocol"
            }]),
            templates_suggestion: (data) => `<div><strong>${data.label}</strong> <em>under Protocols</em></div>`
        };
    }
};
